document.addEventListener('DOMContentLoaded', function () {
    let timeoutId; // timeout per aggiornameto ajax nel carrello
    var formAction;

    //manage update quantity handler in cart page.;
    document.addEventListener("click", event => {
        //minus handler
        if (event.target.matches(".woocommerce-cart form.woocommerce-cart-form .product-quantity .perf-quantity-button.minus")) {
            removeMinusCart(event.target);
        }
        //plus handler
        if (event.target.matches(".woocommerce-cart form.woocommerce-cart-form .product-quantity .perf-quantity-button.plus")) {
            addPlusCart(event.target);
        }
    });

    //manage change input quantity in cart when onchange event is triggered
    document.addEventListener("keyup", event => {
        let keyCode = event.keyCode || event.which;

        // Verifica se il codice corrisponde a un numero (0-9)
        if ((keyCode >= 48 && keyCode <= 57) || keyCode === 8 || keyCode === 46) {
            // Numeri nella tastiera principale (0-9)
            if (event.target.matches(".woocommerce-cart form.woocommerce-cart-form .product-quantity .input-text.qty")) {
                if(event.target.value.length > 0){
                    manageQuantityOnChange(event.target);
                }
            }
        } else if ((keyCode >= 96 && keyCode <= 105) || keyCode === 8 || keyCode === 46) {
            // Numeri nel tastierino numerico (0-9)
            if (event.target.matches(".woocommerce-cart form.woocommerce-cart-form .product-quantity .input-text.qty")) {
                if(event.target.value.length > 0){
                    manageQuantityOnChange(event.target);
                }
            }
        }
    });

    //manage form submit
    document.addEventListener("submit", event => {
        console.log(event.target);
        if (event.target.matches(".woocommerce-cart-form")) {
            event.preventDefault();
            submitCartForm();
        }
    });

    // manage coupon
    document.addEventListener("click", event => {
        //apply
        if (event.target.matches(".actions-update .coupon button.cart-apply-coupon")) {
            event.preventDefault();
            formAction = {
                name: 'apply_coupon',
                content: 'Aggiorna'
            };
            update_cart_via_ajax();
        }
        //remove
        if (event.target.matches("a.woocommerce-remove-coupon")) {
            event.preventDefault();
            console.log('remove product from cart');
            formAction = {
                name: 'remove_coupon',
                content: event.target.dataset.coupon
            };
            let myForm = document.querySelector('.woocommerce-cart-form');
            myForm.action = myForm.action + '?remove_coupon=' + event.target.dataset.coupon;
            update_cart_via_ajax();
        }
    });

    // manage delete product
    document.addEventListener("click", event => {
        if (event.target.matches("a.remove i.icon-delete")) {
            event.preventDefault();
            formAction = {
                name: 'remove_item',
                content: 'remove'
            };
            let myForm = document.querySelector('.woocommerce-cart-form');
            myForm.action = event.target.parentElement.getAttribute('href');
            update_cart_via_ajax();
        }
    });

    // manage undo product
    document.addEventListener("click", event => {
        if (event.target.matches("a.restore-item")) {
            event.preventDefault();
            formAction = {
                name: 'undo_item',
                content: 'remove'
            };
            let myForm = document.querySelector('.woocommerce-cart-form');
            myForm.action = event.target.getAttribute('href');
            update_cart_via_ajax();
        }
    });

    function removeMinusCart(target) {
        const quantityInput = target.parentElement.nextElementSibling.nextElementSibling;

        //get data of quantity
        let val = parseFloat(quantityInput.value);
        let maxAttr = quantityInput.getAttribute('max');
        let max = maxAttr !== null && maxAttr.trim() !== '' ? parseFloat(maxAttr) : null;
        let minAttr = quantityInput.getAttribute('min');
        let min = minAttr !== null && minAttr.trim() !== '' ? parseFloat(minAttr) : null;
        let step = parseFloat(quantityInput.getAttribute('step')) || 1;

        if((val - 1 ) >= 0){
            quantityInput.value = val - step;
        }

        //condizione in cui c'è più quantità del dovuto
        if(max !== null && val > max){
            quantityInput.value = max;
        }

        //use jquery call to enable update button
        const qtyJ = jQuery(target).parent( '.quantity' ).find( '.qty' );
        qtyJ.change();

        formAction = {
            name: 'update_cart',
            content: 'Aggiorna'
        };

        clearTimeout(timeoutId); // Cancella il timeout attuale se presente
        timeoutId = setTimeout(function() {
            update_cart_via_ajax();
        }, 400);
    }

    function addPlusCart(target) {
        const quantityInput = target.parentElement.previousElementSibling;

        //get data of quantity
        let val = parseFloat(quantityInput.value);
        let maxAttr = quantityInput.getAttribute('max');
        let max = maxAttr !== null && maxAttr.trim() !== '' ? parseFloat(maxAttr) : null;
        let minAttr = quantityInput.getAttribute('min');
        let min = minAttr !== null && minAttr.trim() !== '' ? parseFloat(minAttr) : null;
        let step = parseFloat(quantityInput.getAttribute('step')) || 1;

        // Se non è presente un valore massimo, consenti incremento illimitato
        if (max === null || isNaN(max)) {
            quantityInput.value = val + step;
        } else {
            // Se il nuovo valore non supera il massimo, incrementa
            if ((val + step) <= max) {
                quantityInput.value = val + step;
            } else {
                quantityInput.value = max;
            }
        }

        //use jquery call to enable update button
        const qtyJ = jQuery(target).parent( '.quantity' ).find( '.qty' );
        qtyJ.change();

        formAction = {
            name: 'update_cart',
            content: 'Aggiorna'
        };

        if(!(max === null || isNaN(max)) && val >= max){
            const fullQuantity = document.querySelector('p.perf-max-stock');
            if(!fullQuantity){
                let maxVal = document.createElement('p');
                maxVal.textContent = '';
                maxVal.classList.add('text-danger', 'm-0', 'position-absolute','top-100', 'start-0', 'perf-max-stock');
                maxVal.textContent = 'Disponibilità massima raggiunta';
                quantityInput.parentElement.appendChild(maxVal);
            }
            clearTimeout(timeoutId); // Cancella il timeout attuale se presente
            timeoutId = setTimeout(function() {
                update_cart_via_ajax();
            }, 700);
        }else{
            clearTimeout(timeoutId); // Cancella il timeout attuale se presente
            timeoutId = setTimeout(function() {
                update_cart_via_ajax();
            }, 400);
        }
    }

    function submitCartForm(){
        const form = document.querySelector('.woocommerce-cart-form');
        const formData = new FormData(form); // Crea un oggetto FormData basato sul form
        formData.append(formAction.name, formAction.content);
        var spinnerContainer = document.querySelector('.spinner-container');
        spinnerContainer.classList.add('show');
        console.log(formData)
        // Aggiungi il campo nascosto 'update_cart' con il valore 'Aggiorna'
        //see: wp-content/plugins/woocommerce/includes/class-wc-form-handler.php update_cart_action() for details

        // Usa Fetch API per inviare il form, includendo i cookie
        fetch(form.action, {
            method: form.method,
            body: formData,
            headers: {
                'Accept': 'text/html', // Assicurati che il server accetti questo tipo
            },
            credentials: 'include' // Include i cookie nella richiesta
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(html => {

                // Usa DOMParser per convertire la stringa HTML in un documento DOM
                const parser = new DOMParser();
                const docResponse = parser.parseFromString(html, 'text/html');
                const headerCounter = docResponse.querySelector('span.cart-count-circle');
                const minicart = docResponse.querySelector('div#offcanvasCart');
                const cartBody = docResponse.querySelector('.site-main.mt-3'); // Sostituisci 'elementId' con l'ID effettivo
                const cartBottomBar = docResponse.querySelector('.perf-bottom-cart-sticky-bar-wrapper.bottom-bar-show');
                console.log(minicart)
                console.log(headerCounter)

                if (cartBody) {
                    const currentBody = document.querySelector('.site-main.mt-3'); // Usa lo stesso ID usato sopra
                    if (currentBody) {
                        currentBody.replaceWith(cartBody);
                        document.querySelector('.spinner-container').classList.remove('show');
                    }
                    const currentBottomBar = document.querySelector('.perf-bottom-cart-sticky-bar-wrapper.bottom-bar-show');
                    if(currentBottomBar){
                        currentBottomBar.replaceWith(cartBottomBar);
                    }
                }
                if (minicart) {
                    const currentMinicart = document.querySelector('div#offcanvasCart'); // Usa lo stesso ID usato sopra
                    if (currentMinicart) {
                        currentMinicart.replaceWith(minicart);
                    }
                }
                if (headerCounter) {
                    const currentHeaderCounter = document.querySelector('span.cart-count-circle'); // Usa lo stesso ID usato sopra
                    if (currentHeaderCounter) {
                        currentHeaderCounter.replaceWith(headerCounter);
                    }
                }

                jQuery(document).off('click', 'a.woocommerce-remove-coupon');

                jQuery(document).trigger('yith_wcwl_init');

            })
            .catch(error => {
                console.error('Errore nella richiesta Fetch:', error);
            });
    }

    //set quantity input when input change value
    function manageQuantityOnChange(target){
        let val = parseFloat(target.value);
        let max = parseFloat(target.getAttribute('max'));
        let min = parseFloat(target.getAttribute('min'));
        const quantityInput = target;

        if(val < min){
            target.value = min;
        }
        if(val > max){
            target.value = max;
        }

        formAction = {
            name: 'update_cart',
            content: 'Aggiorna'
        };

        if(val >= max){
            const fullQuantity = document.querySelector('p.perf-max-stock');
            if(!fullQuantity){
                let maxVal = document.createElement('p');
                maxVal.textContent = '';
                maxVal.classList.add('text-danger', 'm-0', 'position-absolute','top-100', 'start-0', 'perf-max-stock');
                maxVal.textContent = 'Disponibilità massima raggiunta';
                quantityInput.parentElement.appendChild(maxVal);
            }
            clearTimeout(timeoutId); // Cancella il timeout attuale se presente
            timeoutId = setTimeout(function() {
                update_cart_via_ajax();
            }, 700);
        }else{
            clearTimeout(timeoutId); // Cancella il timeout attuale se presente
            timeoutId = setTimeout(function() {
                update_cart_via_ajax();
            }, 400);
        }
    }

    function update_cart_via_ajax(){
        const button = document.querySelector('.woocommerce-cart-form .actions-update button.button');
        button.disabled = false;
        button.click();
        var spinnerContainer = document.querySelector('.spinner-container');
        spinnerContainer.classList.add('show');
        console.log('update_cart_via_ajax_finish')
    }
})

//add overflow unset for enable position sticky on cart
document.addEventListener("DOMContentLoaded", function() {
    if (document.body.classList.contains("woocommerce-cart")) {
        document.documentElement.classList.add("woocommerce-cart-html");
    }
});



